import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PlayerBagsForPwaDto, TourBagMstrPayload } from '@/api/models';

export type TABLE_TYPE = Table<PlayerBagsForPwaDto>;

export const TABLE = 'tourBag';
const SCHEMA = 'playerId';

export class TourBagDatabase implements DataRepository<PlayerBagsForPwaDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PlayerBagsForPwaDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PlayerBagsForPwaDto): Promise<PlayerBagsForPwaDto> {
    return this.db[TABLE].put(payload);
  }

  add(player: PlayerBagsForPwaDto): Promise<PlayerBagsForPwaDto> {
    return this.update(player);
  }

  list(): Promise<PlayerBagsForPwaDto[]> {
    return this.db[TABLE].toArray();
  }

  bulkAdd(payload: PlayerBagsForPwaDto[]): Promise<PlayerBagsForPwaDto[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  updateBag = async (playerId: number, tourBag: TourBagMstrPayload): Promise<TourBagMstrPayload[] | null> => {
    const player = await this.db[TABLE].get(playerId);
    if (!player) return null;

    let bagExists = false;
    const updatedBags = player.bags.map((bag) => {
      if (bag.headTypeId === tourBag.headTypeId) {
        bagExists = true;
        return { ...bag, ...tourBag };
      }
      return bag;
    });

    if (!bagExists) {
      updatedBags.push(tourBag);
    }

    const updatedPlayer: PlayerBagsForPwaDto = {
      ...player,
      bags: updatedBags,
    };
    await this.db[TABLE].put(updatedPlayer);
    return updatedBags;
  };
}

export const TourBagDB = new TourBagDatabase(db);
